export default {
  required: "Required",
  pattern: {
    value: /[0-9a-zA-Z]{8,}/,
    message: "Minimum eight characters",
  },
};
